/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Select_AllInputs */

const en_ui_select_all = /** @type {(inputs: Ui_Select_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select all`)
};

/** @type {(inputs: Ui_Select_AllInputs) => LocalizedString} */
const ar_ui_select_all = en_ui_select_all;

/** @type {(inputs: Ui_Select_AllInputs) => LocalizedString} */
const he_ui_select_all = en_ui_select_all;

/** @type {(inputs: Ui_Select_AllInputs) => LocalizedString} */
const ur_ui_select_all = en_ui_select_all;

/** @type {(inputs: Ui_Select_AllInputs) => LocalizedString} */
const es_ui_select_all = en_ui_select_all;

/** @type {(inputs: Ui_Select_AllInputs) => LocalizedString} */
const fr_ui_select_all = en_ui_select_all;

/** @type {(inputs: Ui_Select_AllInputs) => LocalizedString} */
const de_ui_select_all = en_ui_select_all;

/** @type {(inputs: Ui_Select_AllInputs) => LocalizedString} */
const pt_ui_select_all = en_ui_select_all;

/** @type {(inputs: Ui_Select_AllInputs) => LocalizedString} */
const hi_ui_select_all = en_ui_select_all;

/** @type {(inputs: Ui_Select_AllInputs) => LocalizedString} */
const bn_ui_select_all = en_ui_select_all;

/**
* | output |
* | --- |
* | "Select all" |
*
* @param {Ui_Select_AllInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const ui_select_all = /** @type {((inputs?: Ui_Select_AllInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Select_AllInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_ui_select_all(inputs)
	if (locale === "he") return he_ui_select_all(inputs)
	if (locale === "ur") return ur_ui_select_all(inputs)
	if (locale === "es") return es_ui_select_all(inputs)
	if (locale === "fr") return fr_ui_select_all(inputs)
	if (locale === "de") return de_ui_select_all(inputs)
	if (locale === "pt") return pt_ui_select_all(inputs)
	if (locale === "hi") return hi_ui_select_all(inputs)
	if (locale === "bn") return bn_ui_select_all(inputs)
	return /** @type {LocalizedString} */ ("Select all")
});